<template>
  <div class="page-login">
    <div class="header">
      <img class="page-header-left" src="@/assets/images/logo.png" alt="" />
      <div class="page-header-right">
        <span @click="getHelp">{{ $t("pages_login_welinkBind_319") }}</span>
        <span @click="toHome">{{ $t("pages_login_welinkBind_320") }}</span>
      </div>
    </div>
    <div class="banner"></div>
    <div class="mobile-logo">
      <img src="@/assets/images/logo.png" alt="" />
    </div>
    <Login ref="login" :title="$t('pages_login_welinkBind_318')">
      <ul-button class="btn-submit" type="primary" @click="login">{{
        $t("pages_login_welinkBind_321")
      }}</ul-button>
    </Login>
  </div>
</template>
<script>
import User from "@/model/user.js";
import { UMOOC_SERVER_HOST, COURSE_WEB_HOST } from "@/config";
import { mapGetters } from "vuex";
import { welinkBand } from "@/api/courseApi";
import Login from "pc/components/login.vue";
import cookie from "@/utils/cookie.js";
export default {
  components: {
    Login,
  },
  data() {
    return {
      user: new User(),
      welinkId: sessionStorage.getItem("welinkId"),
      errorTip: "",
    };
  },
  computed: {
    ...mapGetters({ account: "user/user" }),
  },
  methods: {
    toHome() {
      window.location.href = `${UMOOC_SERVER_HOST}`;
    },
    getHelp() {
      var config = {
        exterinfo: {
          url: encodeURI(window.location.href),
          userAgent: encodeURI(window.navigator.userAgent),
        },
        system: "web",
      };
      if (this.account.userId) {
        config.userId = this.account.userId;
        config.uname = this.account.name;
      }
      xn("setCustomerInfo", config);
      xn("openChat", "kf_20125_template_9999");
    },
    _login(user) {
      let data = {
        loginName: user.loginName,
        password: user.password,
        userId: this.welinkId, // 如果welinkId不对，则welink的app用户账号就没有绑定
        ops: 1,
      };
      welinkBand(data)
        .then((res) => {
          //0 账号密码失效
          if (res.code == 1) {
            cookie.set("USER_INFO", JSON.stringify(res.result));
            cookie.set("AUTHORIZATION", res.result.authorization);
            cookie.set("token", res.result.authorization);
            // window.location.href = "http://192.168.100.192:8000/ulearning/index.html#/index/courseList";
            window.location.href =
              COURSE_WEB_HOST + "/ulearning/index.html#/index/courseList";
          }
        })
        .catch((err) => {});
    },
    login() {
      this.$refs.login.checkInput(this._login);
    },
  },
  destroyed() {
    sessionStorage.removeItem("welinkId");
  },
};
</script>
<style lang="scss" scoped>
::v-deep .ul-page__body-content {
  background-color: inherit;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 10px 16px;
  margin: 0 auto;
  background-color: #fff;
  .page-header-left {
    height: 40px;
    margin-right: 20px;
    cursor: pointer;
  }
  .page-header-right {
    span {
      display: inline-block;
      padding: 0 12px;
      cursor: pointer;
      &:hover {
        color: $--color-primary;
      }
      &:not(:last-child) {
        border-right: $--border-base;
      }
    }
  }
}
.banner {
  height: 160px;
  background-image: url(~@/assets/images/login_banner.png);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.mobile-logo {
  display: none;
}

.form-container {
  position: relative;
  width: 800px;
  background: #fff;
  margin: -90px auto 40px;
  padding: 48px 48px 70px;
  border-radius: 4px;
  .form-title {
    font-weight: 400;
    text-align: center;
  }
  .form-login {
    width: 420px;
    margin: 0 auto;
  }
  .btn-submit {
    height: 44px;
    width: 100%;
  }
  .ul-input {
    height: 44px;
  }
}
@media (max-width: 768px) {
  .header {
    display: none;
  }
  .banner {
    display: none;
  }
  .mobile-logo {
    display: block;
    padding: 42px 0 16px 0;
    text-align: center;
    img {
      height: 40px;
    }
  }
  .form-container {
    position: static;
    width: 100%;
    margin: 0;
    padding: 20px;
    .form-title {
      display: none;
    }
    .form-login {
      width: auto;
    }
  }
}
</style>